<template>
  <div id="dinners">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>监控管理&nbsp;/&nbsp;办宴点列表</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
          <Week @childFn="parentFn"></Week>
         <el-input class="elinputs" v-model="beginData.name" placeholder="请输入办宴点名称"></el-input>
          <el-select v-model="beginData.status" placeholder="状态" class="elinputs">
              <el-option v-for="item in beginData.statuss" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
          </el-select>
          <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
          <el-button type="info" @click="resets">重置</el-button>
        </div>
        <div class="tit">
          <Reset @clkBtn='theBtn'></Reset>
          <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="name" label="办宴点名称" min-width="130"></el-table-column>
            <el-table-column prop="areasName" label="办宴点地址" min-width="260"></el-table-column>
            <el-table-column label="状态" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.status" style="color:#F56C6C">禁用</p>
                    <p class="boldfont" v-else style="color:#67C23A">启用</p>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="sortOrder" label="排序" width="100"></el-table-column> -->
            <el-table-column sortable prop="addTime" label="创建时间" width="180"></el-table-column>
            <el-table-column sortable prop="updateTime" label="更新时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'dinners:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'dinners:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>共<i class="pagingNum">{{total}}</i> 条</span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="添加/编辑办宴点" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 办宴点地址：" v-if="this.mydata.modify==1||this.mydata.modify==2">
                <p>{{mydata.areasName}}<span class="again" @click='again'>修改办宴点</span></p>
            </el-form-item>
            <el-form-item :label="`* ${this.mydata.stat==0?'办宴点选择':'重新选择'}：`" v-if="this.mydata.stat==0||this.mydata.modify==2">
                <Week @childFn="addparentFn"></Week>
            </el-form-item>
            <el-form-item label="* 办宴点名称：">
               <el-input placeholder="请输入办宴点名称" v-model="mydata.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 状 态：">
                <el-radio v-model="mydata.status" label=0>启用</el-radio>
                <el-radio v-model="mydata.status" label=1>禁用</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible=false">取 消</el-button>
            <el-button type="primary" @click="puton(2)">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import Week from '@/components/Week'
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "dinners",
  components: {
    Xlsx,
    EditorBar,
    Week,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
        beginData:{statuss:[{name:'启用',id:1},{name:'禁用',id:0}]},
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname: JSON.stringify({name:'办宴点',hint:'dinners:export'}),
        mydata:{status:'0'},
        multipleSelection:[],
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('dinners:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('dinners:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('dinners:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    // 获取省市传入的id
    // gainSS(i){
    //     this.beginData.areaId = i.id
    // },

    parentFn(i){
        this.beginData.areaId = i.id
    },
    // 修改办宴点
    again(){
      this.mydata.modify = 2
    },
    addparentFn(i){
        this.mydata.areaId = i.id
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-r/banquetPoint/deleteBanquetPoint/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
      this.mydata={status:'0'}
      this.begin()
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(sessionStorage.getItem('xgStat') != 0){
            return this.$message('请选择所属地区到社区/村')
        }
        if(!this.mydata.name){
            return this.$message('请完善必填信息')
        }
        // 判断是点击哪个
        let url = ``
        if(this.mydata.stat==0){
            url = `/api-r/banquetPoint/addBanquetPoint`
        }else if(this.mydata.stat==1){
            url = `/api-r/banquetPoint/updateBanquetPoint`
            if(!this.mydata.areaId){
              this.mydata.areaId = this.mydata.areasId.split(',')[4]
            }
        }
        this.fullscreenLoading = true;
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.begin()
                this.dialogFormVisible = false
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
        });
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        areaId:this.beginData.areaId,
        name:this.beginData.name,
        status:this.beginData.status,
        adminAreasId:userdata.areasId
      });
      this.$axios.post(`/api-r/banquetPoint/getBanquetPointList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        if(i == 0){
            this.mydata.stat = i
            this.mydata.modify = i
            sessionStorage.setItem('xgStat',1)
        }else if(i == 1){
            let obj = JSON.parse(JSON.stringify(row));
            sessionStorage.setItem('xgStat',0)
            obj.stat = i
            if(obj.status){
              obj.status = '1'
            }else{
              obj.status = '0'
            }
            obj.modify = i
            this.mydata = obj
        }
        this.dialogFormVisible = true
    },
    // 删除优惠券
    stop(row,hint) {
      if(hint&&this.btn.indexOf(hint)==-1){
          return this.$message('抱歉，用户暂无该权限')
      }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-r/banquetPoint/deleteBanquetPoint/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#dinners .el-input__inner {
  margin: 10px 0;
}
#dinners .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#dinners .el-menu-item.is-active{
  background: none
}
#dinners .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#dinners .el-tag{
  margin-right: 12px;
}
#dinners .el-select {
  /* margin: 0 8px; */
  /* width: 100%; */
}
#dinners .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#dinners .el-upload-list--picture .el-upload-list__item {
    /* float: left;
    margin-right: 2%; */
}
#dinners .el-form-item__content {
    display: flex;
    flex-wrap: wrap;
    width: 80%
}
#dinners .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#dinners .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#dinners .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#dinners .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#dinners .el-dialog__body {
  height: 100%;
}
#dinners .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#dinners .el-form-item__label{
    width: 120px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
.again{
  color: red;
  margin-left: 16px;
  text-decoration: underline;
  cursor: pointer;

}
</style>
